/*
 * @Description:
 * @Author:
 * @Date: 2022-09-21 16:53:12
 * @LastEditors: Xyyyyyy
 */
import { createRouter, createWebHistory } from 'vue-router'
import layout from '@/views/layout/index.vue'
import Cookies from 'js-cookie'
import { backToLogin, backToHome } from '../utils/login.js'
import layoutWoDeGongZuo from '@/pages/wodegongzuo/index.vue'

const routes = [
  {
    path: '/login',
    meta: { keepAlive: true },
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/:cathchAll(.*)',
    name: '404',
    // 不需要登录
    meta: { keepAlive: true, needLogin: false },
    component: () => import('../../public/404/404.vue')
  },
  {
    path: '/',
    redirect: '/',
    meta: { keepAlive: true },
    component: layout,
    children: [
      // 首页
      {
        path: '/',
        meta: { keepAlive: true },
        component: () => import('@/views/home.vue')
      }
    ]
  },

  // 办公
  {
    path: '/bangong',
    redirect: '/bangong/gongzuohuanjie',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 工作环节
        path: '/bangong/gongzuohuanjie',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/gongzuohuanjie/list.vue')
      },

      {
        // 个人工作任务统计
        path: '/bangong/gongzuorenwutongji',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/gongzuorenwutongji/list.vue')
      },
      {
        // 日常工作
        path: '/bangong/richanggongzuo',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/richanggongzuo/list.vue')
      },
      // {
      //   // 委派临时工作任务
      //   path: '/bangong/weipailinshigongzuojilu',
      //   meta: { keepAlive: true },
      //   component: () => import('@/pages/bangong/views/weipailinshigongzuojilu/list.vue')
      // },

      {
        // 通知公告模板
        path: '/bangong/tongzhigonggaomuban',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/tongzhigonggaomuban/list.vue')
      },
      {
        // 通知公告
        path: '/bangong/tongzhigonggao',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/tongzhigonggao/list.vue')
      },
      {
        // 资料汇编
        path: '/bangong/ziliaohuibian',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/ziliaohuibian/list.vue')
      },

      {
        // 表单管理
        path: '/bangong/biaodanguanli',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/biaodanguanli/list.vue')
      },
      {
        // 请假
        path: '/bangong/qingjia',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/qingjia/list.vue')
      },
      {
        // 请假
        path: '/bangong/wodeqingjiajilu',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/wodeqingjiajilu/list.vue')
      },
      {
        // 审批中心
        path: '/bangong/shenpizhongxin',
        meta: { keepAlive: true },
        component: () => import('@/pages/bangong/views/shenpizhongxin/list.vue')
      }
    ]
  },
  // 数据管理中心系统
  {
    path: '/shujuguanli',
    redirect: '/shujuguanli/shujuguanlihome',
    meta: { keepAlive: true },
    component: layout,
    children: [
      // 首页
      {
        path: '/shujuguanli/shujuguanlihome',
        meta: { keepAlive: true },
        component: () => import('@/pages/shujuguanli/views/shujuguanlihome.vue')
      },
      // PC教师菜单
      {
        path: '/shujuguanli/gonggongshuju/menu',
        meta: { keepAlive: true },
        component: () => import('@/pages/fuzhujuecezhichi/views/menus/menu.vue')
      },

      {
        // 校区管理
        path: '/shujuguanli/gonggongshuju/xiaoqu',
        meta: { keepAlive: true },
        component: () => import('@/pages/shujuguanli/views/gonggongshuju/xiaoqu/list.vue')
      },
      {
        // 校内岗位
        path: '/shujuguanli/gonggongshuju/xiaoneigangwei',
        meta: { keepAlive: true },
        component: () => import('@/pages/shujuguanli/views/gonggongshuju/xiaoneigangwei/list.vue')
      },
      {
        // 字典管理
        path: '/shujuguanli/gonggongshuju/zidian',
        meta: { keepAlive: true },
        component: () => import('@/pages/shujuguanli/views/gonggongshuju/zidian/list.vue')
      },
      {
        // 行政区划
        path: '/shujuguanli/gonggongshuju/xingzhengquhua',
        meta: { keepAlive: true },
        component: () => import('@/pages/shujuguanli/views/gonggongshuju/xingzhengquhua/list.vue')
      },
      {
        // 模块管理
        path: '/shujuguanli/gonggongshuju/moudle',
        meta: { keepAlive: true },
        component: () => import('@/pages/shujuguanli/views/gonggongshuju/moudle/list.vue')
      },
      // {
      //   // 产品版本管理
      //   path: '/shujuguanli/gonggongshuju/chanpinbanben',
      //   meta: { keepAlive: true },
      //   component: () => import('@/pages/shujuguanli/views/gonggongshuju/chanpinbanben/list.vue')
      // },
      {
        // 系统信息
        path: '/shujuguanli/gonggongshuju/xitongxinxi',
        meta: { keepAlive: true },
        component: () => import('@/pages/shujuguanli/views/gonggongshuju/xitongxinxi/list.vue')
      }

    ]
  },
  // 考勤
  {
    path: '/kaoqin',
    redirect: '/kaoqin/kaoqin',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 考勤设备
        path: '/kaoqin/kaoqinshebei',
        meta: { keepAlive: true },
        component: () => import('@/pages/kaoqin/kaoqinshebei/list.vue')
      },
      {
        // 抓拍记录
        path: '/kaoqin/zhuapaijilu',
        meta: { keepAlive: true },
        component: () => import('@/pages/kaoqin/zhuapaijilu/list.vue')
      },
      {
        // 抓拍记录
        path: '/kaoqin/kaoqindakajilu',
        meta: { keepAlive: true },
        component: () => import('@/pages/kaoqin/kaoqindakajilu/list.vue')
      },
      {
        // 考勤时间
        path: '/kaoqin/kaoqinshijian',
        meta: { keepAlive: true },
        component: () => import('@/pages/kaoqin/kaoqinshijian/list.vue')
      },
      {
        // 考勤用户
        path: '/kaoqin/kaoqinyonghu',
        meta: { keepAlive: true },
        component: () => import('@/pages/kaoqin/kaoqinyonghu/list.vue')
      },
      {
        // 考勤记录
        path: '/kaoqin/kaoqinjilu',
        meta: { keepAlive: true },
        component: () => import('@/pages/kaoqin/kaoqinjilu/list.vue')
      },
      {
        // 考勤表
        path: '/kaoqin/kaoqinbiao',
        meta: { keepAlive: true },
        component: () => import('@/pages/kaoqin/kaoqinbiao/list.vue')
      }
    ]
  },
  // 个人中心
  {
    path: '/gerenzhongxin',
    redirect: '/gerenzhongxin/gerenzhongxin',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 考勤表
        path: '/kaoqin/kaoqinbiao',
        meta: { keepAlive: true },
        component: () => import('@/pages/kaoqin/kaoqinbiao/list.vue')
      }
    ]
  },

  // 我的工作
  {
    path: '/wodegongzuo',
    redirect: '/wodegongzuo/wodelisthome',
    meta: { keepAlive: true },
    component: layout,
    children: [

      {
        // 首页
        path: '/wodegongzuo/wodelisthome',
        meta: { keepAlive: true },
        component: () => import('@/pages/wodegongzuo/gerengongzuorenwu/list.vue')
      },
      {
        // 个人工作任务
        path: '/wodegongzuo/gerengongzuorenwu',
        meta: { keepAlive: true },
        component: () => import('@/pages/wodegongzuo/gerengongzuorenwu/list.vue')
      },
      {
        // 委派临时工作任务
        path: '/wodegongzuo/weipailinshigongzuojilu',
        meta: { keepAlive: true },
        component: () => import('@/pages/wodegongzuo/weipailinshigongzuojilu/list.vue')
      },
      {
        // 部门员工工作任务
        path: '/wodegongzuo/bumenrenyuangongzuorenwu',
        meta: { keepAlive: true },
        component: () => import('@/pages/wodegongzuo/bumenrenyuangongzuorenwu/list.vue')
      }
      // {
      //   // 个人工作任务统计
      //   path: '/wodegongzuo/gongzuorenwutongji',
      //   meta: { keepAlive: true },
      //   component: () => import('@/pages/wodegongzuo/gongzuorenwutongji/list.vue')
      // }
    ]
  },

  // 基础设施
  {
    path: '/jichusheshi',
    redirect: '/jichusheshi/jichusheshi',
    meta: { keepAlive: true },
    component: layout,
    children: [

      {
        // 部门管理
        path: '/jichusheshi/xiaoneijigou',
        meta: { keepAlive: true },
        component: () => import('@/pages/jichusheshi/xiaoneijigou/list.vue')
      },
      {
        // 职务管理
        path: '/jichusheshi/zhiwu',
        meta: { keepAlive: true },
        component: () => import('@/pages/jichusheshi/zhiwu/list.vue')
      }
    ]
  },
  // 人事管理
  {
    path: '/renshiguanli',
    redirect: '/renshiguanli/renshiguanli',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 员工管理
        path: '/renshiguanli/jiaozhigong',
        meta: { keepAlive: true },
        component: () => import('@/pages/renshiguanli/jiaozhigong/list.vue')
      },
      {
        // 离职人员
        path: '/renshiguanli/yuangonglizhiguanli',
        meta: { keepAlive: true },
        component: () => import('@/pages/renshiguanli/yuangonglizhiguanli/list.vue')
      }
    ]
  },
  // 工作内容管理
  {
    path: '/gongzuoneirongguanli',
    redirect: '/gongzuoneirongguanli/gongzuoneirongguanli',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 工作类别
        path: '/gongzuoneirongguanli/gongzuoleibie',
        meta: { keepAlive: true },
        component: () => import('@/pages/gongzuoneirongguanli/gongzuoleibie/list.vue')
      },
      {
        // 工作内容
        path: '/gongzuoneirongguanli/gongzuoneirong',
        meta: { keepAlive: true },
        component: () => import('@/pages/gongzuoneirongguanli/gongzuoneirong/list.vue')
      }

    ]
  },
  // 客户管理
  {
    path: '/kehuguanli',
    redirect: '/kehuguanli/kehuguanli',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 客户管理
        path: '/kehuguanli/kehuguanli',
        meta: { keepAlive: true },
        component: () => import('@/pages/kehuguanli/kehuguanli/list.vue')
      }
    ]
  },
  // 运营项目管理
  {
    path: '/yunyingxiangmuguanli',
    redirect: '/yunyingxiangmuguanli/yunyingxiangmuguanli',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 运营项目类别
        path: '/yunyingxiangmuguanli/yunyingxiangmuleibie',
        meta: { keepAlive: true },
        component: () => import('@/pages/yunyingxiangmuguanli/yunyingxiangmuleibie/list.vue')
      },
      {
        // 运营项目维护
        path: '/yunyingxiangmuguanli/yunyingxiangmuweihu',
        meta: { keepAlive: true },
        component: () => import('@/pages/yunyingxiangmuguanli/yunyingxiangmuweihu/list.vue')
      },
      {
        // 运营项目任务统计
        path: '/yunyingxiangmuguanli/yunyingxiangmurenwutongji',
        meta: { keepAlive: true },
        component: () => import('@/pages/yunyingxiangmuguanli/yunyingxiangmurenwutongji/list.vue')
      },
      {
        // 运营项目到款类别
        path: '/yunyingxiangmuguanli/yunyingxiangmudaokuanliebie',
        meta: { keepAlive: true },
        component: () => import('@/pages/yunyingxiangmuguanli/yunyingxiangmudaokuanliebie/list.vue')
      },
      {
        // 回款记录
        path: '/yunyingxiangmuguanli/huikuanjilu',
        meta: { keepAlive: true },
        component: () => import('@/pages/yunyingxiangmuguanli/huikuanjilu/list.vue')
      },
      {
        // 运营项目签约主体
        path: '/yunyingxiangmuguanli/yunyingxiangmuqianyuezhuti',
        meta: { keepAlive: true },
        component: () => import('@/pages/yunyingxiangmuguanli/yunyingxiangmuqianyuezhuti/list.vue')
      },
      {
        // 运营项目招标形式
        path: '/yunyingxiangmuguanli/yunyingxinagmuzhaobiaoxingshi',
        meta: { keepAlive: true },
        component: () => import('@/pages/yunyingxiangmuguanli/yunyingxinagmuzhaobiaoxingshi/list.vue')
      }
    ]
  },
  // 工作部署
  {
    path: '/gongzuobushu',
    redirect: '/gongzuobushu/gongzuobushu',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 分配工作
        path: '/gongzuobushu/fenpeigongzuo',
        meta: { keepAlive: true },
        component: () => import('@/pages/gongzuobushu/fenpeigongzuo/list.vue')
      },
      {
        // 工作清单
        path: '/gongzuobushu/gongzuoqingdan',
        meta: { keepAlive: true },
        component: () => import('@/pages/gongzuobushu/gongzuoqingdan/list.vue')
      },
      {
        // 工作日历
        path: '/gongzuobushu/gongzuorili',
        meta: { keepAlive: true },
        component: () => import('@/pages/gongzuobushu/gongzuorili/list.vue')
      },
      {
        // 日工作总结
        path: '/gongzuobushu/rigongzuozongjie',
        meta: { keepAlive: true },
        component: () => import('@/pages/gongzuobushu/rigongzuozongjie/list.vue')
      },
      {
        // 周工作总结
        path: '/gongzuobushu/zhougongzuozongjie',
        meta: { keepAlive: true },
        component: () => import('@/pages/gongzuobushu/zhougongzuozongjie/list.vue')
      },
      {
        // 月工作总结
        path: '/gongzuobushu/yuegongzuozongjie',
        meta: { keepAlive: true },
        component: () => import('@/pages/gongzuobushu/yuegongzuozongjie/list.vue')
      }

    ]
  },
  // 产品管理
  {
    path: '/chanpinguanli',
    redirect: '/chanpinguanli/chanpinguanli',
    meta: { keepAlive: true },
    component: layout,
    children: [
      {
        // 产品类型
        path: '/chanpinguanli/chanpinleixing',
        meta: { keepAlive: true },
        component: () => import('@/pages/chanpinguanli/chanpinleixing/list.vue')
      },
      {
        // 产品管理
        path: '/chanpinguanli/chanpin',
        meta: { keepAlive: true },
        component: () => import('@/pages/chanpinguanli/chanpin/list.vue')
      },
      {
        // 产品需求
        path: '/chanpinguanli/chanpinxuqiuchaxun',
        meta: { keepAlive: true },
        component: () => import('@/pages/chanpinguanli/chanpinxuqiuchaxun/list.vue')
      },
      {
        // 产品版本管理
        path: '/chanpinguanli/chanpinbanben',
        meta: { keepAlive: true },
        component: () => import('@/pages/chanpinguanli/chanpinbanben/list.vue')
      },
      {
        // 产品工作方向
        path: '/chanpinguanli/chanpingongzuofangxiang',
        meta: { keepAlive: true },
        component: () => import('@/pages/chanpinguanli/chanpingongzuofangxiang/list.vue')
      }

    ]
  }
]
const router = createRouter({
  // history: createWebHashHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload()
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
})

router.beforeEach((to, from, next) => {
  const token = Cookies.get('access_token')
  const account = location.href.replace(location.origin, '').replace(location.search, '')
  if (token) {
    if (account === '/login') {
      backToHome()
    } else {
      next()
    }
  } else {
    if (account === '/login') {
      next()
    } else {
      backToLogin()
    }
  }
})
export default router
